import { AgFinancing, AgFinancingPhase2Status, CollateralType, FieldMonitoringStatus, Phase2 } from '@indigo-ag/schema';

export class FieldMonitoringUtil {
  static hasStarted(fieldMonitoring: Phase2['fieldMonitoring']): boolean {
    return !!fieldMonitoring?.startedAt;
  }

  static hasBeenApproved(status?: FieldMonitoringStatus): boolean {
    return status === FieldMonitoringStatus.COMPLETED;
  }

  static canStart(
    canStartPhase2: AgFinancing['canStartPhase2'],
    collateralType?: CollateralType,
    phaseInfo?: Phase2
  ): boolean {
    let canStartByCollateralType = true;
    if (collateralType === CollateralType.CPR || collateralType === CollateralType.PROMISSORY_NOTE) {
      canStartByCollateralType = !!phaseInfo?.matriculas?.length;
    }

    return !!canStartPhase2 && canStartByCollateralType;
  }

  static canRestart(phaseInfo?: Phase2): boolean {
    return (
      phaseInfo?.fieldMonitoring?.status === FieldMonitoringStatus.COMPLETED &&
      phaseInfo?.status !== AgFinancingPhase2Status.APPROVED &&
      phaseInfo?.status !== AgFinancingPhase2Status.DENIED
    );
  }

  static hasBeenSent(status?: FieldMonitoringStatus): boolean {
    return status === FieldMonitoringStatus.COMPLETED;
  }

  static hasNotBeenSent(status?: FieldMonitoringStatus): boolean {
    return status === FieldMonitoringStatus.IN_PROGRESS;
  }

  static isOnHold(status?: FieldMonitoringStatus): boolean {
    return status === FieldMonitoringStatus.ON_HOLD;
  }

  static canOnHoldResume(phaseInfo?: Phase2): boolean {
    return (
      !!phaseInfo?.fieldMonitoring?.status && phaseInfo?.fieldMonitoring?.status !== FieldMonitoringStatus.COMPLETED
    );
  }
}
